import React from "react";

const AntiRagging = () => {
  return (
    <div className="w-full h-screen">
      <iframe
        src="/rtimodel.pdf"
        title="RTI Nodal Officer Document"
        className="w-full h-full"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default AntiRagging;